// @flow

import _ from 'lodash';
// app
import ko from 'rgs-knockout';
import type { SelectBaseStrategyOptions } from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import { SelectBaseStrategy } from 'rgs-nfd-ui-kit/ko-components/select/base-strategy';
import type { ISelectStrategy } from 'rgs-nfd-ui-kit/ko-components/select/index.flow';

import type { AccidentContract } from '../../../../services/contracts/accident-contract-model';

export type StrategyContractOptions = SelectBaseStrategyOptions & {
	onItemClick: (item: AccidentContract) => void,
	onCancel: () => void,
}

export class ContractSelect
	extends SelectBaseStrategy<AccidentContract>
	implements ISelectStrategy<AccidentContract> {

	_options: StrategyContractOptions;

	withSearch = ko.observable(true);
	withShowLoadAll = ko.observable(true);
	minLengthSearchWord = 1;
	pathToId = 'AccidentContractID';
	pathToName = 'ClientName';
	placeholder = 'Выберите договор';

	constructor (options: StrategyContractOptions) {
		super(options);
		this._options = _.defaults(this._options, {
			onCancel: _.noop,
			onChange: _.noop,
		});

		this.busy.add(this._fetch());
	}

	getItemName (item?: AccidentContract): string {
		if (!item) {
			return undefined;
		}

		const clientName = item.ClientName;
		const contractNumber = item.ContractNumber;

		return `${contractNumber} ${clientName}`;
	}

	async onClickItem (item: AccidentContract): Promise<void> {
		super.onClickItem(item);

		this._options.onItemClick(item);
	}

	onClickCancel (): void {
		super.onClickCancel();

		this._options.onCancel();
	}
}
